export default __webpack_public_path__ + "static/media/Amapiano.360e56d7.PNG";